<template>
    <MainPage @clickBack="clickBack()">
        <div class="max-w-4xl m-auto flex flex-col justify-center items-center py-3.5 px-4 lg:p-0">
            <CreditCardList
                ref="credit-card-list"
            ></CreditCardList>
            <WhiteButton class="mt-2" @click="addNewCard()"
                customClass="w-52 lg:w-64 flex py-2.5 px-2 mx-auto">
                <img class="ml-auto mr-2" src="@/assets/icon/ic-add-red-2.svg" />
                <div class="ml-0 mr-auto text-a-red-d62300 text-14 lg:text-16 font-bold">Add new card</div>
            </WhiteButton>
        </div>
    </MainPage>
</template>
<script>
// conmponents
import MainPage from "@/components/Layout/Page/MainPage.vue";
import WhiteButton from "@/components/Button/WhiteButton.vue";
import CreditCardList from "@/module/CreditCard/component/CreditCardList.vue";
// mixins
import LocaleMixin from "@/mixin/LocaleMixin";

export default {
    name: "CreditDebitCard",
    mixins: [LocaleMixin],
    components: {
        MainPage,
        WhiteButton,
        CreditCardList,
    },
    data: function() {
        return {
            isCardFound: false,
            isLoaded: false,
        }
    },
    methods: {
        addNewCard: function(){
            this.$router.push('/addcreditcard');
        },
        clickBack: function() {
            this.$router.back();
        },
    },

}
</script>
<style lang="scss" scoped>
.h-custom{
    height: calc(100vh - 75px);
}
</style>
